import { Component, OnInit } from '@angular/core';
import { ResponsaveisTecnicosService } from "./responsaveis-tecnicos.service";
import { ResponsaveisTecnicosModel } from "./responsaveis-tecnicos.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-responsaveis-tecnicos',
  templateUrl: './responsaveis-tecnicos.component.html'
})
export class ResponsaveisTecnicosComponent extends Components implements OnInit {

  responsaveisTecnicos: ResponsaveisTecnicosModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  constructor(
    private responsaveisTecnicosService: ResponsaveisTecnicosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '24') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.responsaveisTecnicosService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.responsaveisTecnicos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.responsaveisTecnicos);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  delete(responsavel) {
    let responsaveis = this.responsaveisTecnicos;
    let responsaveisService = this.responsaveisTecnicosService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarResponsavelTecnico') + (responsavel.nome || ''),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(responsaveis);
        }

        let index = responsaveis.indexOf(responsavel);
        responsaveis.splice(index, 1);

        responsaveisService.apagar(responsavel.id)
          .subscribe(res => {
            self.responsaveisTecnicos = responsaveis;
          },
            err => {
              responsaveis.splice(index, 0, responsavel);
              self.responsaveisTecnicos = responsaveis;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.responsaveisTecnicosService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.responsaveisTecnicos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.component.ts